import { IAppState } from '../../common/state';

export function mortgageDataReducer(state: IAppState): IAppState {
  return {
    ...state,
    mortgageData: state.mortgageData || null,
  };
}
